import { gql } from '@apollo/client';

export const GET_NEW_REPORT = gql`
  query NewReport($id: ID!, $projectId: ID!) {
    newReport(id: $id, projectId: $projectId) {
      id
      title
      startDate
      endDate
      createdAt
      updatedAt
      reportHtml
      source
      supplierRequestContext {
        direction
        requestId
        displayName
        status
        pendingRecommendationCount
        lastPublishedAt
      }
      template {
        id
        name
      }
      createdBy {
        id
        firstName
        lastName
      }
      newReportChapter {
        id
        title
        identifier
        position
        dataPoints {
          id
          updatedAt
          dueDate
          templateIdentifier
          title
          description
          position
          type
          options
          value
          subtype
          validation
          conditionalLogic
          metadata
          formula
          isCompleted
          commentCount
          suggestionGenerationStatus
          recommendationGenerationStatus
          recommendationEligible
          documentSuggestions {
            id
            title
            description
          }
          facility {
            id
            name
            type
          }
          assignedTo {
            id
          }
          recommendation {
            id
            targetType
            suggestedValue
            explanation
            confidenceScore
            status
            feedback
          }
          parentDataPoint {
            id
            updatedAt
            dueDate
            templateIdentifier
            title
            description
            position
            type
            options
            value
            subtype
            validation
            conditionalLogic
            metadata
            formula
            isCompleted
            commentCount
            suggestionGenerationStatus
            recommendationGenerationStatus
            recommendationEligible
            facility {
              id
              name
              type
            }
            assignedTo {
              id
            }
            recommendation {
              id
              targetType
              suggestedValue
              explanation
              confidenceScore
              status
              feedback
            }
          }
          childDataPoints {
            id
            updatedAt
            dueDate
            templateIdentifier
            title
            description
            position
            type
            options
            value
            subtype
            validation
            conditionalLogic
            metadata
            formula
            isCompleted
            commentCount
            suggestionGenerationStatus
            recommendationGenerationStatus
            recommendationEligible
            documentSuggestions {
              id
              title
              description
            }
            facility {
              id
              name
              type
            }
            assignedTo {
              id
              firstName
              lastName
            }
            recommendation {
              id
              targetType
              suggestedValue
              explanation
              confidenceScore
              status
              feedback
            }
          }
        }
      }
    }
  }
`;

export const GET_NEW_REPORT_BREADCRUMB = gql`
  query GetNewReportBreadcrumb($id: ID!, $projectId: ID!) {
    newReport(id: $id, projectId: $projectId) {
      id
      title
    }
  }
`;
export const GET_NEW_REPORTS = gql`
  query NewReports($projectId: ID!) {
    newReports(projectId: $projectId) {
      id
      title
      startDate
      endDate
      createdAt
      updatedAt
      processingStatus
      reportHtml
      template {
        id
        name
      }
      supplierRequestContext {
        direction
        requestId
        displayName
        status
        pendingRecommendationCount
        lastPublishedAt
      }
      newReportChapter {
        id
        dataPoints {
          id
          type
          isCompleted
        }
      }
      createdBy {
        id
        firstName
        lastName
        email
      }
    }
  }
`;
